<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">角色标识:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.role"
                  size="small"
                  @keyup.enter.native="searchRole"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">角色名称:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.roleName"
                  size="small"
                  @keyup.enter.native="searchRole"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="12" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px">
              <el-button class="search-btn btn-blue" @click="searchRole">搜索</el-button>
              <el-button class="search-btn btn-green" @click="addRole">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="roleList"
            border
            height="550"
        >
          <el-table-column
              prop="num"
              label="序号"
              align="center"

              width="40">
          </el-table-column>
          <el-table-column
              prop="role"
              label="角色标识"
              align="center"

              width="300">
          </el-table-column>
          <el-table-column
              prop="roleName"
              label="角色名称"
              align="center"

              width="300">
          </el-table-column>
          <el-table-column
              prop="note"
              label="角色描述"

          >
          </el-table-column>
          <el-table-column
              width="300"
              align="center"

              label="操作">
            <template slot-scope="scope">
              <el-button class="list-btn btn-deepblue" @click="editRole(scope.row)">编辑</el-button>
              <el-button class="list-btn btn-blue" @click="roleAuth(scope.row)">权限</el-button>
              <el-button class="list-btn btn-red" @click="delRole(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <el-dialog
        title="添加角色"
        :visible.sync="addRoleDialogVisible"
        width="50%"
        @close="addRoleDialogClose">
      <el-form
          label-width="120px"
          class="add-role-form">
        <el-form-item label="角色标识：">
          <el-input v-model="addRoleInfo.role" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色名称：">
          <el-input v-model="addRoleInfo.roleName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色描述：">
          <el-input v-model="addRoleInfo.note" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button class="form-btn btn-gray" @click="clearAddRoleForm">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="addRoleSave">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="权限管理"
        :visible.sync="authDialogVisible"
        width="50%"
        @close="authDialogClose">
      <el-row style="display:flex;margin-bottom:20px">
        <el-col :span='2'>
          数据权限：
        </el-col>
        <el-col :span='22'>
          <el-radio v-model="authEditParams.permissionFlag" label="0">全部</el-radio>
          <el-radio v-model="authEditParams.permissionFlag" label="1">个人</el-radio>
          <el-radio v-model="authEditParams.permissionFlag" label="2">本部门</el-radio>
          <el-radio v-model="authEditParams.permissionFlag" label="3">本部门及子部门</el-radio>
        </el-col>
      </el-row>
      <el-tree 
          ref="authTree"
          :data="authTreeData"
          show-checkbox
          default-expand-all
          node-key="menuId"
          :default-checked-keys="authTreeSelectedId"
          :props="defaultProps">
      </el-tree>
      <span slot="footer" class="dialog-footer">
          <el-button class="form-btn btn-gray" @click="clearAuth">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="authSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: {tableCon},
  data() {
    return {
      queryInfo: {
        role: '',
        roleName: '',
        pageSize: 10,
        pageNum: 1
      },
      roleList: [],
      total: 0,
      addRoleInfo: {
        roleId: '',
        role: '',
        roleName: '',
        note: '',
        delFlag: ''
      },
      addRoleDialogVisible: false,
      authDialogVisible: false,
      authEditParams: {
        permissionFlag:'0',
        roleId: '',
        roleMenuPermList: []
      },
      authTreeSelectedId: [],
      authTreeData: [],
      defaultProps: {
        children: 'menuTreeChild',
        label: 'menuName',
        id: 'menuId'
      },
    }
  },
  methods: {
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getRoleList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getRoleList();
    },
    addRoleDialogClose() {
      this.addRoleDialogVisible = false;
    },
    authDialogClose() {
      this.authDialogVisible = false;
    },
    clearAddRoleForm() {
      this.initRoleForm();
      this.addRoleDialogVisible = false;
    },
    clearAuth() {
      this.authDialogVisible = false;
    },
    authSave() {
      var _this = this;
      let checkedNodes = this.$refs.authTree.getCheckedNodes();
      this.authEditParams.roleMenuPermList = [];
      checkedNodes.forEach(el => {
        _this.authEditParams.roleMenuPermList.push({
          menuId: el.menuId,
          permission: el.permission,
          flag: el.flag,
          parentMenuId: el.parentMenuId
        })
      });
      this.btnAuthPost()
      this.authDialogVisible = false;
    },
    initRoleForm() {
      this.addRoleInfo = {
        roleId: '',
        role: '',
        roleName: '',
        note: '',
        delFlag: ''
      };
    },
    addRoleSave() {
      this.addEditRolePost(this.addRoleInfo.roleId);
      this.addRoleDialogVisible = false;
    },
    searchRole() {
      this.queryInfo.pageNum = 1;
      this.getRoleList();
    },
    addRole() {
      this.initRoleForm();
      this.addRoleDialogVisible = true;
    },
    roleAuth(row) {
      this.authEditParams.roleId = row.roleId;
      this.getAuthTree();
      this.authDialogVisible = true;
    },
    async delRole(row) {
      var url = 'role/deleteRole';
      const {data: res} = await this.$http.post(url, {roleId: row.roleId});
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getRoleList();
    },
    editRole(row) {
      this.addRoleDialogVisible = true;
      this.addRoleInfo = {
        roleId: row.roleId,
        role: row.role,
        roleName: row.roleName,
        note: row.note
      };
    },
    async btnAuthPost() {
      const {data: res} = await this.$http.post('role/modifyPerm', this.authEditParams);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    async addEditRolePost(id) {
      var url = '';
      if (id && id.length > 0) {
        url = 'role/update';
      } else {
        url = 'role/create';
      }
      const {data: res} = await this.$http.post(url, this.addRoleInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getRoleList();
    },
    async getRoleList() {
      const {data: res} = await this.$http.get('role/list', {params: this.queryInfo});
      res.data.list.map((item, index) => {
        item.num = index + 1
      })
      this.roleList = res.data.list;
      this.total = res.data.total;
    },
    async getAuthTree() {
      const {data: res} = await this.$http.get('role/authInfo', {params: {roleId: this.authEditParams.roleId}});
      if(res.data.permissionFlag !== null){
        this.authEditParams.permissionFlag = res.data.permissionFlag.toString()
      } else {
        this.authEditParams.permissionFlag = '0'
      }
      this.authTreeData = res.data.treeArray;
      this.authTreeSelectedId = res.data.selectedNodeList;
      // this.total = res.data.total;
    }

  },

  created() {
    this.getRoleList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>